<style scoped lang="less">
/deep/ .el-switch__label {
	z-index: 1 !important;
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}

.contenttitles {
	margin: 0.4rem 0;
	font-size: 0.8rem;
	color: #333;
}

/deep/ .el-descriptions-item__cell {
	width: 2vw;
	text-align: center !important;
}

/deep/ .el-dialog__header {
	padding: 14px 19px 10px;
	background: #05a34a;
	color: #fff !important;
	font-size: 1.2rem;

	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 1.4rem;
	}

	.el-dialog__title {
		color: #fff !important;
	}

	.dialog-header-title {
		span {
			margin-left: 0.6rem;
		}
	}
}

/deep/ .el-cascader {
	width: 100%;
}

.grid-content {
	color: #333;
	font-size: 0.8rem;
}

.addinputs {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.8rem 5rem;
	border-radius: 20px;
	box-sizing: border-box;

	span {
		margin-right: 0.6rem;
		font-size: 1rem;
	}

	margin: 1rem auto;
}

.appendschool {
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	justify-content: space-around;
	border-top: 3px solid #6571ff;
	border-radius: 2px;
	margin-bottom: 1rem;

	.appendschoolicon {
		margin: 0 1rem;
		width: 2rem;
		height: 2rem;
		background: #6571ff;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 1.4rem;
		border-radius: 50%;
	}

	.appconten {
		.appchooltitle {
			font-size: 1.2rem;
			color: #333;
			font-weight: 500;
			width: 100%;
			border-bottom: 1px solid #ccc;
			padding-bottom: 0.6rem;
			margin-bottom: 1rem;
			box-sizing: border-box;
		}

		/deep/ .el-row {
			margin: 0 0 0.8rem 0;

			p {
				margin: 0 0 0.4rem 0;
			}
		}

		.uplog {
			display: flex;
			align-items: center;

			button {
				margin-bottom: 1.2rem;
				border: 1px dashed #ccc;
				padding: 0.4rem 1rem;
				border-radius: 1rem;

				i {
					font-size: 1rem;
					margin-right: 0.4rem;
					color: #22af47;
				}
			}

			img {
				width: 4rem;
				height: 4rem;
				margin-left: 1rem;
				margin-top: -1rem;
			}
		}
	}
}

.schoollist {
	// margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #22af47;
	border-radius: 2px;

	.schooltitle {
		font-size: 1.2rem;
		color: #22af47;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		.renovate {
			padding: 0.4rem;
			width: 6rem;
			height: 1.6rem;
			background: #ffb236;
			border-radius: 5px;
			color: #fff;
			position: absolute;
			left: 12rem;
			display: flex;
			align-items: center;
			justify-content: space-around;

			span {
				vertical-align: middle;
				margin-bottom: 0.2rem;
				font-weight: 700;
				color: #fff;
				font-size: 1rem;
			}
		}

		button {
			padding: 0.4rem 1rem;
			background: #ffc107;
			font-size: 0.6rem;
			border-radius: 3px;
			position: absolute;
			right: 1%;

			span {
				color: #000;
			}
		}

		span.el-icon-s-management {
			width: 2rem;
			display: flex;
			height: 2rem;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 1.4rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #22af47;
			color: #fff;
			justify-content: center;
			align-items: center;
		}
	}
}

.tabslis {
	/deep/ & ::-webkit-scrollbar {
		width: 5px;
		height: 8px;
		background: linear-gradient(to right, #2e61bf, #60c363);
	}

	& ::-webkit-scrollbar {
		width: 10px;
		height: 5px;
		// background: red;
	}

	& ::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	/deep/ .el-table {
		th,
		td {
			// text-align: center;
			// height: 2rem;
		}

		// tr:nth-child(2n) {
		// 	background-color: #fff;

		// }

		// tr:nth-child(2n-1) {
		// 	background-color: #F2F2F2;
		// }

		td {
			button {
				color: #fff;
				border-radius: 5px;
				font-size: 0.6rem;
			}

			.looking {
				background: #0d6efd;
				margin-left: 10px;

				// span {
				// 	font-size: 1.2rem;
				// }
			}

			.looking:hover {
				background: #0b67e6;
			}

			.giveempower {
				background: #ff8300;

				// span {
				// 	font-size: 1.2rem;
				// }
			}

			.edit {
				background: #17a001;

				// span {
				// 	font-size: 1.2rem;
				// }
			}

			.edit:hover {
				background: #1fcf00;
			}

			.delete {
				background: #ec0f25;

				// span {
				// 	font-size: 1.2rem;
				// }
			}

			.delete:hover {
				background: #ff1128;
			}
		}
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.schoolconten {
		p {
			height: 4rem;
			overflow: hidden;
			white-space: pre-wrap !important;
			text-overflow: ellipsis;
			text-align: left;
		}

		text-overflow: ellipsis;
	}

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.looking {
	background: #0d6efd;
	margin-left: 10px;

	// span {
	// 	font-size: 1.2rem;
	// }
}

.looking:hover {
	background: #0b67e6;
}

.giveempower {
	background: #ff8300;

	// span {
	// 	font-size: 1.2rem;
	// }
}

.edit {
	background: #17a001;

	// span {
	// 	font-size: 1.2rem;
	// }
}

.edit:hover {
	background: #1fcf00;
}

.delete {
	background: #ec0f25;

	// span {
	// 	font-size: 1.2rem;
	// }
}

.delete:hover {
	background: #ff1128;
}

/* 动画 */
@keyframes danchu {
	from {
		transform: translateX(-100%);
		opacity: 0;
	}

	to {
		opacity: 1;
		transform: translateX(0px);
	}
}

.v-enter-active {
	animation: danchu 1s linear;
}

.v-leave-active {
	animation: danchu 1s linear reverse;
}

.clubs,
.zhuy {
	.tabslis .el-table td .edit {
		margin-left: 11px;
	}
}

.chiosceqx {
	margin-bottom: 0.4rem;
	// border-bottom: 1px solid #ccc;
	// border-left: 1px solid #ccc;
	// border-right: 1px solid #ccc;
	// padding-bottom:1rem;
}

.chioqxtitel {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: #f8f8f8;
	border: 1px solid #ccc;
	padding: 0.4rem 0.8rem;

	p {
		margin: 0 !important;
	}
}

.chioxqxcontent {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 1rem;

	.chioxqleft {
		margin-right: 2rem;
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		/deep/ .el-checkbox__label {
			font-size: 0.8rem;
			color: #333;
		}
	}
}

& .activejs {
	display: none !important;
}

.defuilt {
	display: block;
}

.v-enter-active,
.v-leave-active {
	transition: all 0.8s ease;
}

.v-enter,
.v-leave-to {
	transform: translateY(100px);
	opacity: 0;
}

.chioxqcontent {
	/deep/ .el-checkbox {
		margin: 0 1rem;
	}
}
</style>
<template>
	<div>
		<transition>
			<div class="appendschool" v-show="isShow" :style="{ 'border-color': mangesnames.topcolor }">
				<div class="appendschoolicon" :style="{ background: mangesnames.topcolor }"><span class="el-icon-s-management"></span></div>
				<div class="appconten" style="width: 100%;">
					<p class="appchooltitle">添加新{{ mangesnames.name }}</p>
					<form>
						<el-row :gutter="20">
							<el-col :span="24">
								<div class="grid-content">
									<p class="contenttitles">
										{{ mangesnames.name }}名称
										<span style="color: red;margin-left: 4px;">（必填）</span>
									</p>
									<input
										v-model="addzypageobj.name"
										type="text"
										maxlength="20"
										class="form-control"
										id="inlineFormInput"
										:placeholder="'输入' + mangesnames.name + '名称'"
									/>
								</div>
							</el-col>
							<el-col :span="24" style="margin-top: 0.4rem;">
								<div class="grid-content ">
									<p class="contenttitles">{{ mangesnames.name }}备注</p>

									<input
										v-model="addzypageobj.remark"
										maxlength="20"
										type="text"
										class="form-control"
										id="inlineFormInput"
										:placeholder="'输入' + mangesnames.name + '描述'"
									/>
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="20" v-if="mangesnames.name == '部门'">
							<el-col :span="12">
								<div class="grid-content">
									<p class="contenttitles">所属院校</p>
									<el-select
										@input="seletescool()"
										v-model="selectedschoole"
										:options="optionsschoole"
										size="sm"
										class="form-control"
										id="exampleFormControlSelect1"
									></el-select>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-content">
									<p>所属上级部门</p>
									<el-select v-model="selectedclub" :options="optionsclub" size="sm" class="form-control" id="exampleFormControlSelect1"></el-select>
								</div>
							</el-col>
						</el-row>

						<!-- <el-row :gutter="20" v-if="mangesnames.name == '专业'">
							<el-col :span="24">
								<div class="grid-content">
									<p>
										所属院校
										<span style="color: red;margin-left: 4px;">（必填）</span>
									</p>
									<select v-model="zysiguid" class="form-control" id="exampleFormControlSelect1">
										<option value="">-- 请选择院校 --</option>
										<option v-for="(item, index) in optischoole" :key="index" :label="item.si_name_cn" :value="item.si_guid">{{ item.si_name_cn }}</option>
									</select>
								</div>
							</el-col>
						</el-row> -->

						<el-row :gutter="20" v-if="mangesnames.name == '角色'">
							<el-col :span="24">
								<div class="grid-content">
									<p class="contenttitles">{{ mangesnames.name }}权限</p>
									<div class="chiosceqx" v-for="(item, index) in jsoptions" :key="index">
										<div class="chioqxtitel">
											<p>
												<el-checkbox v-model="item.IsChecked" @change="handleCheckChangeall(item, index)">{{ item.au_name }}</el-checkbox>
											</p>
											<p @click="changesjs(index)" style="cursor: pointer;">展开</p>
										</div>
										<transition>
											<div class="defuilt " :class="{ activejs: flag[index] }">
												<div class="chioxqxcontent animate__fadeInDown">
													<div class="chioxqleft">
														<div
															v-for="(ite, idx) in item.AuthoriyParent"
															:key="idx"
															style="display: flex;justify-content: flex-start;flex-wrap: wrap;"
														>
															<el-checkbox v-model="ite.IsChecked" @change="handleCheckChange(ite)">{{ ite.au_name }}</el-checkbox>
															<div class="chioxqcontent" v-for="(it, id) in ite.AuthoriyParent" :key="id">
																<el-checkbox v-model="it.IsChecked" @change="handleCheckChange(it)">{{ it.au_name }}</el-checkbox>
															</div>
														</div>
													</div>
												</div>
											</div>
										</transition>
									</div>
								</div>
							</el-col>
							<el-col :span="24">
								<div class="grid-content">
									<p class="contenttitles">{{ mangesnames.name }}关联菜单</p>
									<div class="chiosceqx" v-for="(item, index) in cdoptions" :key="index">
										<div class="chioqxtitel">
											<p>
												<el-checkbox v-model="item.IsChecked" @change="handleCheckChangemuneall(item, index)">{{ item.mu_name_cn }}</el-checkbox>
											</p>
											<p @click="changesjsmune(index)" style="cursor: pointer;">展开</p>
										</div>
										<transition>
											<div class="defuilt " :class="{ activejs: menuflag[index] }">
												<div class="chioxqxcontent animate__fadeInDown">
													<div class="chioxqleft">
														<div v-for="(ite, idx) in item.MenuParent" :key="idx" style="display: flex;justify-content: flex-start;">
															<el-checkbox v-model="ite.IsChecked" @change="handleCheckChangemune(ite)">{{ ite.mu_name_cn }}</el-checkbox>
															<div class="chioxqcontent" v-for="(it, id) in ite.MenuParent" :key="id">
																<el-checkbox v-model="it.IsChecked" @change="handleCheckChangemune(it)">{{ it.mu_name_cn }}</el-checkbox>
															</div>
														</div>
													</div>
												</div>
											</div>
										</transition>
									</div>
								</div>
							</el-col>
						</el-row>

						<el-row :gutter="20" v-if="mangesnames.name == '权限'">
							<el-col :span="24" style="margin-bottom: 0.6rem;">
								<div class="grid-content">
									<p class="contenttitles">权限编号</p>
									<input v-model="addzypageobj.au_sysCode" type="text" class="form-control" id="inlineFormInput" placeholder="输入权限编号" />
								</div>
							</el-col>
							<el-col :span="24">
								<div class="grid-content">
									<p class="contenttitles">
										父权限
										<span style="color: red;">（根据父类添加子类)</span>
									</p>
									<el-cascader
										@change="qxcahnges()"
										v-model="qxvalue"
										:options="qxoptions"
										:props="{ checkStrictly: true, label: 'au_name', value: 'au_guid', children: 'AuthoriyParent' }"
										clearable
									></el-cascader>
								</div>
							</el-col>
						</el-row>

						<el-row :gutter="20" v-if="mangesnames.name == '班级'">
							<el-col :span="12">
								<div class="grid-content">
									<p>
										所属院校
										<span style="color: red;margin-left: 4px;">（必填）</span>
									</p>
									<select @change="schoolzylist()" v-model="zysiguid" class="form-control" id="exampleFormControlSelect1">
										<option value="">-- 请选择院校 --</option>
										<option v-for="(item, index) in optischoole" :key="index" :label="item.si_name_cn" :value="item.si_guid">{{ item.si_name_cn }}</option>
									</select>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-content">
									<p>
										所属专业
										<span style="color: red;margin-left: 4px;">（必填）</span>
									</p>
									<select v-model="zyproguid" class="form-control" id="exampleFormControlSelect1">
										<option value="">-- 请选择专业 --</option>
										<option v-for="(item, index) in scoolzylist" :key="index" :label="item.pro_name" :value="item.pro_guid">{{ item.pro_name }}</option>
									</select>
								</div>
							</el-col>
							<el-col :span="24">
								<div class="grid-content" style="margin-top: 1rem;">
									<p>{{ mangesnames.name }}编号</p>
									<input v-model="addzypageobj.cla_nameNumber" type="text" class="form-control" id="inlineFormInput" placeholder="输入班级编号" />
								</div>
							</el-col>
						</el-row>
					</form>
					<button @click="addspecialty()" class="addinputs" style="color: #fff;" :style="{ background: mangesnames.topcolor }" v-preventReClick>
						<span class="icon-user-follow" style="font-weight:800;color: #fff;"></span>
						添加{{ mangesnames.name }}
					</button>
				</div>
			</div>
		</transition>

		<div class="schoollist" :style="{ 'border-color': mangesnames.contentcolor }" :class="{ clubs: mangesnames.name == '部门', zhuy: mangesnames.name == '专业' }">
			<p class="schooltitle">
				<span
					v-if="mangesnames.isshows == null ? true : false"
					class="el-icon-s-management"
					:style="{ background: mangesnames.contentcolor }"
					style="color: #fff;margin:0 1rem;"
				></span>
				<span style="color: #333;letter-spacing: 1px;">{{ mangesnames.name }}数据列表</span>
				<button @click="uptatesdata()" v-if="mangesnames.isshows == null ? true : false" class="renovate">
					<span class="el-icon-refresh " :class="{ 'fa-spin': isfaspin }"></span>
					刷新数据
				</button>

				<el-tooltip class="item" effect="dark" :content="isShow ? '隐藏功能区' : '显示功能区'" placement="left-end">
					<button v-if="mangesnames.isshows == null ? true : false" @click="checshows()" style="color: #fff;" :style="{ background: mangesnames.topcolor }">
						<span class="icon-user-follow" style="font-weight:800;color: #fff;"></span>
						添加{{ mangesnames.name }}
					</button>
				</el-tooltip>
			</p>

			<div class="tables">
				<div class="tabslist">
					<div class="paginations">
						每页显示
						<input @change="changepaage()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesobj.pageSize" />
						行
					</div>
					<div class="tabslis" v-if="mangesnames.name != '预约'">
						<template>
							<el-table
								v-if="mangesnames.name == '权限'"
								:data="tableData"
								style="width: 100%;margin-bottom: 20px;"
								header-row-class-name="tablestitle"
								border
								row-key="au_guid"
								:tree-props="{ children: 'AuthoriyParent' }"
							>
								<el-table-column prop="au_name" label="权限名称" sortable width="240"></el-table-column>
								<el-table-column prop="au_sysCode" label="权限编号" sortable width="240"></el-table-column>
								<el-table-column prop="au_remark" label="备注"></el-table-column>
								<el-table-column fixed="right" label="操作" width="180">
									<template slot-scope="scope">
										<div class="userusec d-sm-none d-md-block">
											<el-button size="small" @click="handleClick(scope.row)" class="edit">编辑</el-button>
											<el-button size="small" class="delete" @click="tabledeletes(scope.row)">删除</el-button>
										</div>
										<div class="userusec d-sm-block d-md-none">
											<el-dropdown trigger="click">
												<p class="el-dropdown-link">···</p>
												<el-dropdown-menu slot="dropdown">
													<el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
														<el-button size="small" @click="handleClick(scope.row)" class="edit">
															<span class="fas fa-eye-dropper" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>

													<el-tooltip class="item" effect="dark" content="删除" placement="right-start">
														<el-button size="small" class="delete" @click="tabledeletes(scope.row)">
															<span class="el-icon-delete" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</template>
								</el-table-column>
							</el-table>

							<el-table :data="tableData" style="width: 100%" header-row-class-name="tablestitle" v-if="mangesnames.name != '权限'">
								<!-- <el-table-column fixed type="selection" width="55">
									</el-table-column> -->
								<el-table-column
									v-for="(item, index) in tabtitlelists"
									:key="index"
									:el-table-column="item.label"
									:label="item.label"
									:prop="item.prop"
								></el-table-column>

								<el-table-column fixed="right" label="操作" v-if="mangesname.name == '角色'">
									<template slot-scope="scope">
										<div class="userusec d-sm-none d-md-block">
											<el-button size="small" :class="'looking'" @click="lookClick(scope.row)">
												<!-- <span class="el-icon-view"></span> -->
												查看
											</el-button>
											<el-button size="small" @click="handleClick(scope.row)" class="edit">
												<!-- <span class="fas fa-eye-dropper"></span> -->
												编辑
											</el-button>
											<el-button size="small" class="delete" @click="tabledeletes(scope.row)">
												<!-- <span class="el-icon-delete"></span> -->
												删除
											</el-button>
										</div>
										<div class="userusec d-sm-block d-md-none">
											<el-dropdown trigger="click">
												<p class="el-dropdown-link">···</p>
												<el-dropdown-menu slot="dropdown">
													<el-tooltip class="item" effect="dark" content="查看" placement="left-end">
														<el-button size="small" :class="'looking'" @click="lookClick(scope.row)">
															<span class="el-icon-view" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>
													<el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
														<el-button size="small" @click="handleClick(scope.row)" class="edit">
															<span class="fas fa-eye-dropper" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>

													<el-tooltip class="item" effect="dark" content="删除" placement="right-start">
														<el-button size="small" class="delete" @click="tabledeletes(scope.row)">
															<span class="el-icon-delete" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</template>
								</el-table-column>

								<el-table-column fixed="right" label="操作" v-if="mangesname.name == '部门'">
									<template slot-scope="scope">
										<div class="userusec d-sm-none d-md-block">
											<!-- <el-button size="small" :class="'looking'">
													<span class="el-icon-view"></span>
													查看菜单
												</el-button> -->
											<el-button size="small" @click="handleClick(scope.row)" class="edit">
												<!-- <span class="fas fa-eye-dropper"></span> -->
												编辑
											</el-button>
											<el-button size="small" class="delete" @click="tabledeletes(scope.row)">
												<!-- <span class="el-icon-delete"></span> -->
												删除
											</el-button>
										</div>
										<div class="userusec d-sm-block d-md-none">
											<el-dropdown trigger="click">
												<p class="el-dropdown-link">···</p>
												<el-dropdown-menu slot="dropdown">
													<!-- <el-tooltip class="item" effect="dark" content="查看菜单"
															placement="left-end">
															<el-button size="small" :class="'looking'">
																<span class="el-icon-view" style="color: #fff;"></span>
															</el-button>
														</el-tooltip> -->

													<el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
														<el-button size="small" @click="handleClick(scope.row)" class="edit">
															<span class="fas fa-eye-dropper" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>

													<el-tooltip class="item" effect="dark" content="删除" placement="right-start">
														<el-button size="small" class="delete" @click="tabledeletes(scope.row)">
															<span class="el-icon-delete" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</template>
								</el-table-column>

								<el-table-column fixed="right" label="操作" v-if="mangesname.name == '专业' || mangesname.name == '班级'">
									<template slot-scope="scope">
										<div class="userusec d-sm-none d-md-block">
											<el-button size="small" @click="handleClick(scope.row)" class="edit">编辑</el-button>
											<el-button size="small" class="delete" @click="tabledeletes(scope.row)">删除</el-button>
										</div>
										<div class="userusec d-sm-block d-md-none">
											<el-dropdown trigger="click">
												<p class="el-dropdown-link">···</p>
												<el-dropdown-menu slot="dropdown">
													<el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
														<el-button size="small" @click="handleClick(scope.row)" class="edit">
															<span class="fas fa-eye-dropper" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>

													<el-tooltip class="item" effect="dark" content="删除" placement="right-start">
														<el-button size="small" class="delete" @click="tabledeletes(scope.row)">
															<span class="el-icon-delete" style="color: #fff;"></span>
														</el-button>
													</el-tooltip>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</div>

					<div class="tabsnum">
						<p>
							显示
							<span>1</span>
							到
							<span>{{ pagesobj.pageSize }}</span>
							,共
							<span>{{ pagesobj.maxpages }}</span>
							条记录
						</p>
						<div class="elpagian">
							<el-pagination
								@current-change="handleCurrentChange"
								background
								layout="prev, pager, next"
								:page-size="pagesge"
								:total="pagesobj.maxpages"
							></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog :show-close="false" :title="mangesnames.name + '编辑'" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
			<div v-if="mangesnames.name == '专业'">
				<el-row :gutter="20">
					<el-col :span="12">
						<div class="grid-content">
							<p style="margin-bottom: 0.4rem;">
								{{ mangesnames.name }}名称
								<span style="color: red;margin-left: 4px;">（必填）</span>
							</p>
							<input v-model="addzypageobjs.name" type="text" class="form-control" id="inlineFormInput" :placeholder="'输入' + mangesnames.name + '名称'" />
						</div>
					</el-col>
					<el-col :span="12">
						<div class="grid-content ">
							<p style="margin-bottom: 0.4rem;">{{ mangesnames.name }}备注</p>
							<input v-model="addzypageobjs.remark" type="text" class="form-control" id="inlineFormInput" :placeholder="'输入' + mangesnames.name + '备注'" />
						</div>
					</el-col>
				</el-row>
				<!-- <el-row :gutter="20" style="margin-top: 1rem;">
					<el-col :span="24">
						<div class="grid-content ">
							<p style="margin-bottom: 0.4rem;">
								所属院校
								<span style="color: red;margin-left: 4px;">（必填）</span>
							</p>
							<select v-model="addzypageobjs.si_guid" class="form-control" id="exampleFormControlSelect1">
								<option value="">-- 请选择院校 --</option>
								<option v-for="(item, index) in optischoole" :key="index" :label="item.si_name_cn" :value="item.si_guid">{{ item.si_name_cn }}</option>
							</select>
						</div>
					</el-col>
				</el-row> -->
			</div>

			<div v-if="mangesnames.name == '权限'">
				<el-row :gutter="20">
					<el-col :span="12">
						<div class="grid-content ">
							<p style="margin-bottom: 0.4rem;">{{ mangesnames.name }}编号</p>
							<input v-model="addauthpageobjs.au_sysCode" type="text" class="form-control" id="inlineFormInput" :placeholder="'输入' + mangesnames.name + '备注'" />
						</div>
					</el-col>
					<el-col :span="12">
						<div class="grid-content" style="margin-bottom: 1rem;">
							<p style="margin-bottom: 0.4rem;">{{ mangesnames.name }}名称</p>
							<input
								v-model="addauthpageobjs.au_name"
								maxlength="20"
								type="text"
								class="form-control"
								id="inlineFormInput"
								:placeholder="'输入' + mangesnames.name + '名称'"
							/>
						</div>
					</el-col>
					<el-col :span="24">
						<div class="grid-content ">
							<p style="margin-bottom: 0.4rem;">{{ mangesnames.name }}备注</p>
							<input v-model="addauthpageobjs.au_remark" type="text" class="form-control" id="inlineFormInput" :placeholder="'输入' + mangesnames.name + '备注'" />
						</div>
					</el-col>
					<el-col :span="24" style="margin-top: 1rem;">
						<div class="grid-content ">
							<p style="margin-bottom: 0.4rem;">所属父级{{ mangesnames.name }}</p>
							<el-cascader
								@change="qxcahnges1()"
								v-model="addauthpageobjs.au_parentGuid"
								:options="qxoptions"
								:props="{ checkStrictly: true, label: 'au_name', value: 'au_guid', children: 'AuthoriyParent' }"
								clearable
							></el-cascader>
						</div>
					</el-col>
				</el-row>
			</div>

			<div v-if="mangesnames.name == '班级'">
				<el-row :gutter="20">
					<el-col :span="12">
						<div class="grid-content">
							<p style="margin-bottom:0.4rem;">
								{{ mangesnames.name }}名称
								<span style="color: red;margin-left: 4px;">（必填）</span>
							</p>
							<input
								v-model="addzypageobjs.name"
								maxlength="20"
								type="text"
								class="form-control"
								id="inlineFormInput"
								:placeholder="'输入' + mangesnames.name + '名称'"
							/>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="grid-content">
							<p style="margin-bottom:0.4rem;">{{ mangesnames.name }}编号</p>
							<input v-model="addzypageobjs.cla_nameNumber" type="text" class="form-control" id="inlineFormInput" placeholder="输入班级编号" />
						</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" style="margin-top: 1rem;">
					<el-col :span="12">
						<div class="grid-content" style="margin-top: 0.4rem;">
							<p style="margin-bottom: 0.4rem;">
								所属院校
								<span style="color: red;margin-left: 4px;">（必填）</span>
							</p>
							<select @change="schoolzylists(addzypageobjs.si_guid)" v-model="addzypageobjs.si_guid" class="form-control" id="exampleFormControlSelect1">
								<option value="">-- 请选择院校 --</option>
								<option v-for="(item, index) in optischoole" :key="index" :label="item.si_name_cn" :value="item.si_guid">{{ item.si_name_cn }}</option>
							</select>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="grid-content" style="margin-top: 0.4rem;">
							<p style="margin-bottom: 0.4rem;">
								所属专业
								<span style="color: red;margin-left: 4px;">（必填）</span>
							</p>
							<select v-model="addzypageobjs.pro_guid" class="form-control" id="exampleFormControlSelect1">
								<option value="">-- 请选择专业 --</option>
								<option v-for="(item, index) in scoolzylist" :key="index" :label="item.pro_name" :value="item.pro_guid">{{ item.pro_name }}</option>
							</select>
						</div>
					</el-col>
					<el-col :span="24" style="margin-top: 1rem;">
						<div class="grid-content ">
							<p style="margin-bottom:0.4rem;">{{ mangesnames.name }}备注</p>
							<!-- <el-input v-model="addzypageobjs.bjremark" type="textarea" :rows="6" >
							</el-input> -->
							<textarea v-model="addzypageobjs.bjremark" id="" rows="20" style="width: 100%;border: 1px solid #ccc;padding: 1rem;"></textarea>
						</div>
					</el-col>
				</el-row>
			</div>

			<div v-if="mangesnames.name == '角色'">
				<el-row :gutter="20">
					<el-col :span="24">
						<div class="grid-content">
							<p class="contenttitles">
								{{ mangesnames.name }}名称
								<span style="color: red;margin-left: 4px;">（必填）</span>
							</p>
							<input
								v-model="addzypageobjs.rl_name"
								maxlength="20"
								type="text"
								class="form-control"
								id="inlineFormInput"
								:placeholder="'输入' + mangesnames.name + '名称'"
							/>
						</div>
					</el-col>
					<el-col :span="24">
						<div class="grid-content">
							<p class="contenttitles">{{ mangesnames.name }}备注</p>
							<!-- <input  maxlength="60" type="text" 
								id="inlineFormInput" > -->
							<textarea
								v-model="addzypageobjs.rl_remark"
								id="inlineFormInput"
								class="form-control"
								cols="100"
								rows="10"
								:placeholder="'输入' + mangesnames.name + '备注'"
							></textarea>
						</div>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="24">
						<div class="grid-content">
							<p class="contenttitles">{{ mangesnames.name }}权限</p>
							<div class="chiosceqx" v-for="(item, index) in jsoptionsedic" :key="index">
								<div class="chioqxtitel">
									<p>
										<el-checkbox v-model="item.IsChecked" @change="handleCheckChangealledit(item, index)">{{ item.au_name }}</el-checkbox>
									</p>
									<p @click="changesjs(index)" style="cursor: pointer;">展开</p>
								</div>
								<transition>
									<div class="defuilt " :class="{ activejs: flag[index] }">
										<div class="chioxqxcontent animate__fadeInDown">
											<div class="chioxqleft">
												<div v-for="(ite, idx) in item.AuthoriyParent" :key="idx" style="display: flex;justify-content: flex-start;flex-wrap: wrap;">
													<el-checkbox v-model="ite.IsChecked">{{ ite.au_name }}</el-checkbox>
													<div class="chioxqcontent" v-for="(it, id) in ite.AuthoriyParent" :key="id">
														<el-checkbox v-model="it.IsChecked">{{ it.au_name }}</el-checkbox>
													</div>
												</div>
											</div>
										</div>
									</div>
								</transition>
							</div>
						</div>
					</el-col>
					<el-col :span="24">
						<div class="grid-content">
							<p class="contenttitles">{{ mangesnames.name }}关联菜单</p>
							<div class="chiosceqx" v-for="(item, index) in cdoptionsedic" :key="index">
								<div class="chioqxtitel">
									<p>
										<el-checkbox v-model="item.IsChecked" @change="handleCheckChangemunealledic(item, index)">{{ item.mu_name_cn }}</el-checkbox>
									</p>
									<p @click="changesjsmune(index)" style="cursor: pointer;">展开</p>
								</div>
								<transition>
									<div class="defuilt " :class="{ activejs: menuflag[index] }">
										<div class="chioxqxcontent animate__fadeInDown">
											<div class="chioxqleft">
												<div v-for="(ite, idx) in item.MenuParent" :key="idx" style="display: flex;justify-content: flex-start;">
													<el-checkbox v-model="ite.IsChecked" @change="handleCheckChangemune(ite)">{{ ite.mu_name_cn }}</el-checkbox>
													<div class="chioxqcontent" v-for="(it, id) in ite.MenuParent" :key="id">
														<el-checkbox v-model="it.IsChecked" @change="handleCheckChangemune(it)">{{ it.mu_name_cn }}</el-checkbox>
													</div>
												</div>
											</div>
										</div>
									</div>
								</transition>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dentenpzy(addzypageobj)" v-preventReClick>确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :show-close="false" :title="mangesnames.name + '查看'" :visible.sync="lookdialogVisible" width="60%" :before-close="handleClose">
			<div v-if="mangesnames.name == '角色'">
				<el-row :gutter="20">
					<el-col :span="24">
						<div class="grid-content">
							<p class="contenttitles">
								{{ mangesnames.name }}名称
								<span style="color: red;margin-left: 4px;">（必填）</span>
							</p>
							{{ addzypageobjs.rl_name }}
						</div>
					</el-col>
					<el-col :span="12">
						<div class="grid-content">
							<p class="contenttitles">{{ mangesnames.name }}备注</p>
							{{ addzypageobjs.rl_remark }}
						</div>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="24">
						<div class="grid-content">
							<p class="contenttitles">{{ mangesnames.name }}权限</p>
							<div class="chiosceqx" v-for="(item, index) in jsoptionsedic" :key="index">
								<div class="chioqxtitel">
									<p>
										<el-checkbox v-model="item.IsChecked" disabled @change="handleCheckChangealledit(item, index)">{{ item.au_name }}</el-checkbox>
									</p>
									<!-- <p @click="changesjs(index)" style="cursor: pointer;">展开</p> -->
								</div>
								<transition>
									<div>
										<div class="chioxqxcontent animate__fadeInDown">
											<div class="chioxqleft">
												<div v-for="(ite, idx) in item.AuthoriyParent" :key="idx" style="display: flex;justify-content: flex-start;flex-wrap: wrap;">
													<el-checkbox v-model="ite.IsChecked" disabled>{{ ite.au_name }}</el-checkbox>
													<div class="chioxqcontent" v-for="(it, id) in ite.AuthoriyParent" :key="id">
														<el-checkbox v-model="it.IsChecked" disabled>{{ it.au_name }}</el-checkbox>
													</div>
												</div>
											</div>
										</div>
									</div>
								</transition>
							</div>
						</div>
					</el-col>
					<el-col :span="24">
						<div class="grid-content">
							<p class="contenttitles">{{ mangesnames.name }}关联菜单</p>
							<div class="chiosceqx" v-for="(item, index) in cdoptionsedic" :key="index">
								<div class="chioqxtitel">
									<p>
										<el-checkbox v-model="item.IsChecked" disabled @change="handleCheckChangemunealledic(item, index)">{{ item.mu_name_cn }}</el-checkbox>
									</p>
									<!-- <p @click="changesjsmune(index)" style="cursor: pointer;">展开</p> -->
								</div>
								<transition>
									<div>
										<div class="chioxqxcontent animate__fadeInDown">
											<div class="chioxqleft">
												<div v-for="(ite, idx) in item.MenuParent" :key="idx" style="display: flex;justify-content: flex-start;">
													<el-checkbox v-model="ite.IsChecked" disabled @change="handleCheckChangemune(ite)">{{ ite.mu_name_cn }}</el-checkbox>
													<div class="chioxqcontent" v-for="(it, id) in ite.MenuParent" :key="id">
														<el-checkbox v-model="it.IsChecked" disabled @change="handleCheckChangemune(it)">{{ it.mu_name_cn }}</el-checkbox>
													</div>
												</div>
											</div>
										</div>
									</div>
								</transition>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="lookdialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="lookdialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import {
	getzyInsertOrEdit,
	getzyDelete,
	getzyTrainSingle,
	GetqxAuthInsertOrEdit,
	GetqxAuthDelete,
	GetbjGetSchoolList,
	GetbjInsertOrEdit,
	GetbjDelete,
	GetzyProfList,
	AuthoriyGetAuthList,
	AuthoriyGetMenuList,
	AuthoriyRoleInsertOrEdit,
	AuthoriyRoleDeleteList
} from '@/request/api/mange/mange.js';
import $ from 'jquery';

export default {
	props: {
		mangesname: Object,
		tablist: Array,
		tabtitlelist: Array,
		pagesobj: Object
	},
	data() {
		return {
			isfaspin: false,
			lookdialogVisible: false,
			// 角色
			cdoptionsedic: [],
			jsoptionsedic: [],
			qxchecked: false,
			jscheckList: [],
			jsoptions: [],
			flag: [],
			cdoptions: [],
			jslistindex: 0,
			autos: [],
			autosnune: [],
			menuflag: [],
			anmuntobj: {
				rl_guid: '',
				rl_name: '',
				rl_parentGuid: '',
				rl_remark: ''
			},
			// 权限
			addauthpageobjs: {},
			qxvalue: '',
			qxvalues1: '',
			qxoptions: [],
			qxtableData: [],
			qxvalues: '',
			// 专业院校id
			zysiguid: '',
			zyproguid: '',
			// 弹窗
			dialogVisible: false,
			scoolfid: null,
			scolozyfid: null,
			scoopeolfid: '',
			addzypageobjs: {},
			addzypageobj: {
				name: '',
				guid: '',
				parentGuid: '',
				remark: '',
				qxusers: '',
				munugl: '',
				au_parentGuid: '',
				au_name: '',
				cla_name: '',
				pro_guid: ''
			},
			isshows: false,
			isShow: this.mangesname.show,
			tabsnun: 10,
			mangesnames: this.mangesname,
			tableData: this.tablist,
			tabtitlelists: this.tabtitlelist,
			pagesobjs: this.pagesobj,
			selectedschoole: '0a',
			optionsschoole: [],
			optischoole: [],
			scoolzylist: [],
			selectedclub: 'a',
			optionsclub: [
				{
					value: 'a',
					text: '无'
				},
				{
					value: 'b',
					text: '湖南省教育局'
				}
			],
			zylistnode: '0a',
			zylist: [
				{
					value: 'a',
					text: '无'
				},
				{
					value: 'b',
					text: '科技研发专业'
				}
			]
		};
	},
	beforeMount() {
		if (this.mangesnames.name == '权限' || this.mangesnames.name == '角色') {
			this.getauthon();
			this.getmenulist();
		}
	},
	methods: {
		checshows() {
			this.isShow = !this.isShow;
			if (this.mangesnames.name == '班级' && this.isShow) {
				this.getuserschool();
			}
		},

		uptatesdata() {
			this.isfaspin = true;
			let that = this;
			window.setTimeout(() => {
				that.isfaspin = false;
			}, 3000);
		},

		// 查看角色
		lookClick(e) {
			this.lookdialogVisible = true;
			this.addzypageobjs = e;
			this.clearchecked();

			this.addzypageobjs.RoleAuthList.forEach(itemchked => {
				this.jsoptionsedic.forEach(item => {
					if (itemchked.au_guid == item.au_guid) {
						item.IsChecked = true;
					} else {
						item.AuthoriyParent.forEach(ite => {
							if (itemchked.au_guid == ite.au_guid) {
								ite.IsChecked = true;
							} else {
								ite.AuthoriyParent.forEach(it => {
									if (itemchked.au_guid == it.au_guid) {
										it.IsChecked = true;
									}
								});
							}
						});
					}
				});
			});

			this.addzypageobjs.RoleMenuList.forEach(itemchked => {
				this.cdoptionsedic.forEach(item => {
					if (itemchked.mu_guid == item.mu_guid) {
						item.IsChecked = true;
					} else {
						item.MenuParent.forEach(ite => {
							if (itemchked.mu_guid == ite.mu_guid) {
								ite.IsChecked = true;
							} else {
								ite.MenuParent.forEach(it => {
									if (itemchked.mu_guid == it.mu_guid) {
										it.IsChecked = true;
									}
								});
							}
						});
					}
				});
			});
		},

		// 清空选择菜单
		clearchecked() {
			this.cdoptionsedic.forEach(item => {
				item.IsChecked = false;
				item.MenuParent.forEach(ite => {
					ite.IsChecked = false;
					ite.MenuParent.forEach(it => {
						it.IsChecked = false;
					});
				});
			});

			this.jsoptionsedic.forEach(item => {
				item.IsChecked = false;
				item.AuthoriyParent.forEach(ite => {
					ite.IsChecked = false;
					ite.AuthoriyParent.forEach(it => {
						it.IsChecked = false;
					});
				});
			});

			this.jsoptions.forEach(item => {
				item.IsChecked = false;
				item.AuthoriyParent.forEach(ite => {
					ite.IsChecked = false;
					ite.AuthoriyParent.forEach(it => {
						it.IsChecked = false;
					});
				});
			});

			this.cdoptions.forEach(item => {
				item.IsChecked = false;
				item.MenuParent.forEach(ite => {
					ite.IsChecked = false;
					ite.MenuParent.forEach(it => {
						it.IsChecked = false;
					});
				});
			});
		},

		// 菜单不分页
		getmenulist() {
			AuthoriyGetMenuList().then(res => {
				// console.log(res, '菜单不分页');
				this.cdoptions = JSON.parse(JSON.stringify(res.data.data));
				this.cdoptionsedic = JSON.parse(JSON.stringify(res.data.data));
				this.cdoptions.forEach(item => {
					item.jsztpice = false;
				});
			});
		},
		// 角色选择
		handleCheckChangeall(item, i) {
			// 赋值操作
			if (item.IsChecked) {
				this.jsoptions[i].AuthoriyParent.forEach(item1 => {
					item1.IsChecked = true;
					item1.AuthoriyParent.forEach(ite => {
						ite.IsChecked = true;
					});
				});
			} else {
				this.jsoptions[i].AuthoriyParent.forEach(item1 => {
					item1.IsChecked = false;
					item1.AuthoriyParent.forEach(ite => {
						ite.IsChecked = false;
					});
				});
			}
		},
		handleCheckChangealledit(item, i) {
			// 赋值操作
			if (item.IsChecked) {
				this.jsoptionsedic[i].AuthoriyParent.forEach(item1 => {
					item1.IsChecked = true;
					item1.AuthoriyParent.forEach(ite => {
						ite.IsChecked = true;
					});
				});
			} else {
				this.jsoptionsedic[i].AuthoriyParent.forEach(item1 => {
					item1.IsChecked = false;
					item1.AuthoriyParent.forEach(ite => {
						ite.IsChecked = false;
					});
				});
			}
		},

		handleCheckChangemuneall(item, i) {
			// 赋值操作
			if (item.IsChecked) {
				this.cdoptions[i].MenuParent.forEach(item1 => {
					item1.IsChecked = true;
					item1.MenuParent.forEach(ite => {
						ite.IsChecked = true;
					});
				});
			} else {
				this.cdoptions[i].MenuParent.forEach(item1 => {
					item1.IsChecked = false;
					item1.MenuParent.forEach(ite => {
						ite.IsChecked = false;
					});
				});
			}
		},

		handleCheckChangemunealledic(item, i) {
			// 赋值操作
			// console.log("修改")

			if (item.IsChecked) {
				this.cdoptionsedic[i].MenuParent.forEach(item1 => {
					item1.IsChecked = true;
					item1.MenuParent.forEach(ite => {
						ite.IsChecked = true;
					});
				});
			} else {
				this.cdoptionsedic[i].MenuParent.forEach(item1 => {
					item1.IsChecked = false;
					item1.MenuParent.forEach(ite => {
						ite.IsChecked = false;
					});
				});
			}
		},

		handleCheckChangemune(i) {
			// console.log(i);
		},

		// 角色展开与关闭
		changesjs(i) {
			let f = (this.flag[i] = !this.flag[i]);
			this.$set(this.flag, i, f);
		},
		// 菜单展开与关闭
		changesjsmune(i) {
			// $(".chioxqxcontent").show(2000).siblings().hide(2000)
			// this.jslistindex = i
			let f = (this.menuflag[i] = !this.menuflag[i]);
			this.$set(this.menuflag, i, f);
		},
		// 选择权限
		qxcahnges() {
			// console.log(this.qxvalue)
			let quvalue = this.qxvalue[this.qxvalue.length - 1];
			// console.log(quvalue);
			this.qxvalues = quvalue;
		},
		qxcahnges1() {
			// console.log(this.qxvalue)
			let quvalue = this.addauthpageobjs.au_parentGuid[this.addauthpageobjs.au_parentGuid.length - 1];
			// console.log(quvalue);
			this.addauthpageobjs.au_parentGuid = quvalue;
		},

		// 获取权限不分页
		getauthon() {
			AuthoriyGetAuthList().then(res => {
				// console.log(res);
				this.qxoptions = res.data.data;

				this.jsoptions = JSON.parse(JSON.stringify(res.data.data));
				this.jsoptionsedic = JSON.parse(JSON.stringify(res.data.data));
				let qeobjall = {
					au_name: '默认最高权限',
					au_guid: '111'
				};
				this.qxoptions.unshift(qeobjall);
				this.jsoptions.forEach(item => {
					item.jsztpice = false;
				});
			});
		},

		// 更改院校获取专业
		schoolzylist() {
			// console.log('触发change事');
			this.getzytProfList(this.zysiguid);
		},
		schoolzylists(siguid) {
			this.getzytProfList(siguid);
		},

		// 获取专业列表
		getzytProfList(proguid = localStorage.getItem('siguid')) {
			GetzyProfList(proguid).then(res => {
				// console.log(res, '专业不分页');
				this.optionsschoole = res.data.data;
				this.scoolzylist = res.data.data;
				if (this.optionsschoole.length > 0) {
					this.optionsschoole.forEach((item, index) => {
						item.value = index + 'a';
						item.text = item.pro_name;
					});
				}
			});
		},
		// 更改所属专业
		selezypromis() {
			let siname = '';
			// console.log(this.zylistnode)
			this.optionsschoole.forEach(item => {
				if (item.value == this.zylistnode) {
					siname = item.pro_guid;
					return;
				}
			});
			this.scoopeolfid = siname;
			// console.log(this.scoopeolfid)
		},

		// 更改所属院校
		seletescool() {
			// console.log(this.selectedschoole)
			let siname = '';
			this.optischoole.forEach(item => {
				if (item.value == this.selectedschoole) {
					siname = item.si_name_cn;
					return;
				}
			});
			this.scoolfid = siname.si_guid;
		},

		getschools() {
			GetbjGetSchoolList().then(res => {
				// console.log(res)
				this.optischoole = res.data.data;
				this.optischoole.forEach((item, index) => {
					item.value = index + 'a';
					item.text = item.si_name_cn;
				});
				// console.log(this.optischoole);
			});
		},
		// 弹窗确定
		dentenpzy(e) {
			if (this.mangesnames.name == '专业') {
				// console.log(this.addzypageobjs.name)
				if (!this.addzypageobjs.name || this.addzypageobjs.si_guid == '') {
					this.$message('专业名称或院校不能为空');
				} else {
					let insertoredi1 = {
						pro_guid: this.addzypageobjs.guid,
						pro_name: this.addzypageobjs.name,
						pro_parentGuid: this.addzypageobjs.pro_parentGuid,
						pro_remark: this.addzypageobjs.remark,
						si_guid: this.addzypageobjs.si_guid
					};
					getzyInsertOrEdit(insertoredi1).then(res => {
						// console.log(res)
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.dialogVisible = false;
							// this.addzypageobjs = {}
							this.$parent.PageProfLis();
						} else {
							this.$message(res.data.msg);
						}
					});
				}
			} else if (this.mangesnames.name == '班级') {
				if (this.addzypageobjs.name == '' || this.addzypageobjs.si_guid == '' || this.addzypageobjs.pro_guid == '') {
					this.$message('班级名称名称或院校，专业不能为空');
				} else {
					let bjclas = {
						cla_guid: this.addzypageobjs.cla_guid,
						cla_name: this.addzypageobjs.name,
						cla_nameNumber: this.addzypageobjs.cla_nameNumber,
						cla_remark: this.addzypageobjs.bjremark,
						si_guid: this.addzypageobjs.si_guid,
						pro_guid: this.addzypageobjs.pro_guid
					};
					// console.log(bjclas.si_guid)

					GetbjInsertOrEdit(bjclas).then(res => {
						// console.log(res);
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.addzypageobjs = {};
							this.dialogVisible = false;
							this.$parent.getClassList();
						} else {
							this.$message(res.data.msg);
						}
					});
				}
			} else if (this.mangesnames.name == '权限') {
				let insertoredi = {
					au_guid: this.addauthpageobjs.au_guid,
					au_sysCode: this.addauthpageobjs.au_sysCode,
					au_name: this.addauthpageobjs.au_name,
					au_parentGuid: this.addauthpageobjs.au_parentGuid == '111' ? '' : this.addauthpageobjs.au_parentGuid,
					au_remark: this.addauthpageobjs.au_remark
				};
				// console.log(insertoredi, '进入权限选择');

				if (insertoredi.au_name == '') {
					this.$message('权限名称不能为空');
				} else {
					GetqxAuthInsertOrEdit(insertoredi).then(res => {
						// console.log(res);
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.addzypageobj = {};
							this.$parent.getauthority();
							this.dialogVisible = false;
						} else {
							this.$message(res.data.msg);
						}
					});
				}
			} else if (this.mangesnames.name == '角色') {
				// console.log('角色');
				if (this.addzypageobjs.name == '') {
					this.$message('角色名字不能为空');
				} else {
					this.setRoleInsertOrEdittoo();
				}
			}
		},

		// 返回
		handleClose(done) {
			// this.$confirm('确认关闭？')
			// 	.then(_ => {
			// 		done();
			// 	})
			// 	.catch(_ => {});
		},

		// 删除
		tabledeletes(rowobj) {
			if (this.mangesnames.name == '专业') {
				// console.log(rowobj);
				this.$confirm('确定删除这条记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						getzyDelete(rowobj.pro_guid).then(res => {
							if (res.data.code == 1) {
								this.$message({
									message: '恭喜你，' + res.data.msg,
									type: 'success'
								});
								this.$parent.PageProfLis();
							} else {
								this.$message(res.data.msg);
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			} else if (this.mangesnames.name == '权限') {
				this.$confirm('确定删除这条记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						GetqxAuthDelete(rowobj.au_guid).then(res => {
							if (res.data.code == 1) {
								this.$message({
									message: '恭喜你，' + res.data.msg,
									type: 'success'
								});

								this.$parent.getauthority();
							} else {
								this.$message(res.data.msg);
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			} else if (this.mangesnames.name == '班级') {
				this.$confirm('确定删除这条记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						GetbjDelete(rowobj.cla_guid).then(res => {
							if (res.data.code == 1) {
								this.$message({
									message: '恭喜你，' + res.data.msg,
									type: 'success'
								});
								let bjDele = {
									pageIndex: this.pagesobjs.pageIndex,
									pageSize: this.pagesobj.pageSize,
									cla_name: '',
									si_guid: ''
								};
								this.$parent.getClassList(bjDele);
							} else {
								this.$message(res.data.msg);
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			} else if (this.mangesnames.name == '角色') {
				this.$confirm('确定删除这条记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						let delerole = {
							rl_guid: [rowobj.rl_guid]
						};
						AuthoriyRoleDeleteList(delerole).then(res => {
							if (res.data.code == 1) {
								this.$message({
									message: '恭喜你，' + res.data.msg,
									type: 'success'
								});
								this.$parent.getjsuser();
								this.clearchecked();
							} else {
								this.$message(res.data.msg);
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			}
		},
		// 编辑
		handleClick(e) {
			if (this.mangesnames.name == '专业') {
				console.log(e.si_guid, '专业');
				this.dialogVisible = true;
				this.addzypageobjs.name = e.pro_name;
				this.addzypageobjs.remark = e.pro_remark;
				this.addzypageobjs.guid = e.pro_guid;
				this.addzypageobjs.parentGuid = e.pro_parentGuid;
				this.addzypageobjs.si_guid = e.si_guid;
			} else if (this.mangesnames.name == '部门') {
				this.dialogVisible = true;
			} else if (this.mangesnames.name == '权限') {
				this.dialogVisible = true;
				this.addauthpageobjs = e;
				this.addauthpageobjs.au_parentGuid = this.addauthpageobjs.au_parentGuid == '' ? ['111'] : this.addauthpageobjs.au_parentGuid;
				// console.log(this.addauthpageobjs, '这是子节点');
				// this.addzypageobjs.remark = e.au_remark
			} else if (this.mangesnames.name == '班级') {
				this.getuserschool();
				this.dialogVisible = true;
				this.addzypageobjs.name = e.cla_name;
				this.addzypageobjs.bjremark = e.cla_remark;
				this.addzypageobjs.cla_guid = e.cla_guid;
				this.addzypageobjs.cla_nameNumber = e.cla_nameNumber;
				this.addzypageobjs.si_guid = e.si_guid;
				this.addzypageobjs.pro_guid = e.pro_guid;
			} else if (this.mangesnames.name == '角色') {
				this.dialogVisible = true;
				this.addzypageobjs = {};
				this.addzypageobjs = JSON.parse(JSON.stringify(e));
				this.clearchecked();
				if (this.addzypageobjs.RoleAuthList.length > 0) {
					this.addzypageobjs.RoleAuthList.forEach(itemchked => {
						this.jsoptionsedic.forEach(item => {
							if (itemchked.au_guid == item.au_guid) {
								item.IsChecked = true;
							} else {
								item.AuthoriyParent.forEach(ite => {
									if (itemchked.au_guid == ite.au_guid) {
										ite.IsChecked = true;
									} else {
										ite.AuthoriyParent.forEach(it => {
											if (itemchked.au_guid == it.au_guid) {
												it.IsChecked = true;
											}
										});
									}
								});
							}
						});
					});
				} else {
					this.jsoptionsedic.forEach(item => {
						item.IsChecked = false;
						item.AuthoriyParent.forEach(ite => {
							ite.IsChecked = false;
							ite.AuthoriyParent.forEach(it => {
								it.IsChecked = false;
							});
						});
					});
				}

				if (this.addzypageobjs.RoleMenuList.length > 0) {
					this.addzypageobjs.RoleMenuList.forEach(itemchked => {
						this.cdoptionsedic.forEach(item => {
							if (itemchked.mu_guid == item.mu_guid) {
								item.IsChecked = true;
							} else {
								item.MenuParent.forEach(ite => {
									if (itemchked.mu_guid == ite.mu_guid) {
										ite.IsChecked = true;
									} else {
										ite.MenuParent.forEach(it => {
											if (itemchked.mu_guid == it.mu_guid) {
												it.IsChecked = true;
											}
										});
									}
								});
							}
						});
					});
				} else {
					this.cdoptionsedic.forEach(item => {
						item.IsChecked = false;
						item.MenuParent.forEach(ite => {
							ite.IsChecked = false;
							ite.MenuParent.forEach(it => {
								it.IsChecked = false;
							});
						});
					});
				}
				// console.log(this.cdoptionsedic);
			}
		},

		// 添加
		addspecialty() {
			if (this.mangesnames.name == '专业') {
				let insertoredi = {
					pro_guid: '',
					pro_name: this.addzypageobj.name,
					pro_parentGuid: '',
					pro_remark: this.addzypageobj.remark
				};
				// si_guid: this.zysiguid
				getzyInsertOrEdit(insertoredi).then(res => {
					// console.log(res);
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.zysiguid = '';
						this.$parent.PageProfLis();
						this.addzypageobj = {};
					} else {
						this.$message(res.data.msg);
					}
				});
			} else if (this.mangesnames.name == '权限') {
				let insertoredi = {
					au_guid: '',
					au_sysCode: this.addzypageobj.au_sysCode,
					au_name: this.addzypageobj.name,
					au_parentGuid: this.qxvalues == '111' ? '' : this.qxvalues,
					au_remark: this.addzypageobj.remark
				};
				// console.log(insertoredi, '进入权限选择');

				if (insertoredi.au_name == '') {
					this.$message('权限名称不能为空');
				} else {
					GetqxAuthInsertOrEdit(insertoredi).then(res => {
						// console.log(res);
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.addzypageobj = {};
							this.qxvalue = '';
							this.$parent.getauthority();
							this.getauthon();
						} else {
							this.$message(res.data.msg);
						}
					});
				}
			} else if (this.mangesnames.name == '班级') {
				if (this.addzypageobj.name == undefined || this.zysiguid == '' || this.zyproguid == '') {
					this.$message('班级名称名称或院校，专业不能为空');
				} else {
					let bjclas = {
						cla_guid: '',
						cla_name: this.addzypageobj.name,
						cla_nameNumber: this.addzypageobj.cla_nameNumber,
						cla_remark: this.addzypageobj.remark,
						si_guid: this.zysiguid,
						pro_guid: this.zyproguid
					};

					GetbjInsertOrEdit(bjclas).then(res => {
						// console.log(res);
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.addzypageobj = {};
							this.zysiguid = '';
							this.zyproguid = '';
							this.$parent.getClassList();
						} else {
							this.$message(res.data.msg);
						}
					});
				}
			} else if (this.mangesnames.name == '角色') {
				if (this.addzypageobj.name == '') {
					this.$message('角色名字不能为空');
				} else {
					this.setRoleInsertOrEdit();
				}
			}
		},

		// 角色修改
		setRoleInsertOrEdittoo() {
			this.cdoptionsedic.forEach(item => {
				item.MenuParent.forEach(ite => {
					if (ite.IsChecked) {
						this.autosnune.push(ite.mu_guid);
					}
					ite.MenuParent.forEach(it => {
						if (it.IsChecked) {
							this.autosnune.push(it.mu_guid);
						}
					});
				});
				if (item.IsChecked) {
					this.autosnune.push(item.mu_guid);
				}
			});

			this.jsoptionsedic.forEach(item => {
				item.AuthoriyParent.forEach(ite => {
					if (ite.IsChecked) {
						this.autos.push(ite.au_guid);
					}
					ite.AuthoriyParent.forEach(it => {
						if (it.IsChecked) {
							this.autos.push(it.au_guid);
						}
					});
				});
				if (item.IsChecked) {
					// console.log('默认选中');
					this.autos.push(item.au_guid);
				}
			});

			let anmunt = {
				rl_guid: this.addzypageobjs.rl_guid,
				rl_name: this.addzypageobjs.rl_name,
				rl_parentGuid: this.addzypageobjs.rl_parentGuid,
				rl_remark: this.addzypageobjs.rl_remark,
				authList: Array.from(new Set(this.autos)),
				menuList: Array.from(new Set(this.autosnune))
			};
			// console.log(anmunt)

			AuthoriyRoleInsertOrEdit(anmunt).then(res => {
				// console.log(res)
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.dialogVisible = false;
					this.anmuntobj = {};
					this.autos = [];
					this.autosnune = [];
					this.$parent.getjsuser();
					// location.reload();
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		setRoleInsertOrEdit() {
			this.cdoptions.forEach(item => {
				item.MenuParent.forEach(ite => {
					if (ite.IsChecked) {
						this.autosnune.push(ite.mu_guid);
					}
					ite.MenuParent.forEach(it => {
						if (it.IsChecked) {
							this.autosnune.push(it.mu_guid);
						}
					});
				});
				if (item.IsChecked) {
					this.autosnune.push(item.mu_guid);
				}
			});

			this.jsoptions.forEach(item => {
				item.AuthoriyParent.forEach(ite => {
					if (ite.IsChecked) {
						this.autos.push(ite.au_guid);
					}
					ite.AuthoriyParent.forEach(it => {
						if (it.IsChecked) {
							this.autos.push(it.au_guid);
						}
					});
				});
				if (item.IsChecked) {
					// console.log('默认选中');
					this.autos.push(item.au_guid);
				}
			});

			let anmunt = {
				rl_guid: this.anmuntobj.rl_guid,
				rl_name: this.addzypageobj.name,
				rl_parentGuid: this.anmuntobj.rl_parentGuid,
				rl_remark: this.addzypageobj.remark,
				authList: Array.from(new Set(this.autos)),
				menuList: Array.from(new Set(this.autosnune))
			};
			// console.log(anmunt);

			AuthoriyRoleInsertOrEdit(anmunt).then(res => {
				// console.log(res);
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.addzypageobj.name = '';
					this.addzypageobj.remark = '';
					this.autos = [];
					this.autosnune = [];
					this.$parent.getjsuser();
					this.clearchecked();
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		handleCurrentChange(val) {
			if (this.mangesnames.name == '专业') {
				this.pagesobjs.pageIndex = val;
				this.$parent.PageProfLis(this.pagesobjs);
			} else if (this.mangesnames.name == '角色') {
				// console.log('角色变化');
				this.pagesobjs.pageIndex = val;
				this.$parent.getjsuser(this.pagesobjs);
			} else if (this.mangesnames.name == '权限') {
				this.pagesobjs.pageIndex = val;
				this.$parent.getauthority(this.pagesobjs);
			} else if (this.mangesnames.name == '班级') {
				this.pagesobjs.pageIndex = val;
				this.$parent.getClassList(this.pagesobjs);
			}
		},
		changepaage() {
			// console.log(this.pagesobjs);
			this.pagesobjs.pageIndex = 1;
			if (this.mangesnames.name == '专业') {
				// console.log(this.pagesobjs)
				this.$parent.PageProfLis(this.pagesobjs);
			} else if (this.mangesnames.name == '角色') {
				this.$parent.getjsuser(this.pagesobjs);
			} else if (this.mangesnames.name == '权限') {
				this.$parent.getauthority(this.pagesobjs);
			} else if (this.mangesnames.name == '班级') {
				this.$parent.getClassList(this.pagesobjs);
			}
		},
		getuserschool() {
			this.getzytProfList();
			this.getschools();
		}
	},

	watch: {
		tablist(val) {
			this.tableData = val;
		},
		tabtitlelist(val) {
			this.tabtitlelists = val;
		},
		pagesobj(val) {
			this.pagesobjs = val;
		},
		jslistindex() {}
	},
	computed: {
		pagesge() {
			return Number(this.pagesobj.pageSize);
		}
	},
	mounted() {
		// console.log(this.tabtitlelist);
		// console.log(this.mangesnames.isshows)
	}
};
</script>

<style></style>
